import { FC } from "react";

interface NotFoundContentProps {
	message?: string;

	compact?: boolean;
	fullWidth?: boolean;
}

export const NotFoundContent: FC<NotFoundContentProps> = ({
	message = "No data found",
	compact = false,
	fullWidth = true,
}) => {
	return (
		<div
			className={[
				fullWidth ? "w-full" : "inline-block",
				"rounded-lg border border-dashed border-muted-foreground/20",
				"bg-muted/30",
				compact ? "px-3 py-2" : "px-4 py-6",
			].join(" ")}
			role="status"
			aria-live="polite"
		>
			<div className="flex items-center justify-center gap-2 text-muted-foreground">
				<span className="text-sm font-medium">{message}</span>
			</div>
		</div>
	);
};
